const sv = {
  pleaseEnterUsername: "Vänligen ange ett användarnamn",
  cannotFriendYourself: "Du kan inte skicka en vänförfrågan till dig själv.",
  friendRequestSent: "Vänförfrågan skickad!",
  failedToSendRequest: "Det gick inte att skicka förfrågan",
  linkCopied: "Länken har kopierats till urklipp!",
  backToInvites: "Tillbaka till inbjudningar",
  sendFriendRequestByUsername: "Skicka vänförfrågan med användarnamn",
  enterUsername: "Ange användarnamn",
  send: "Skicka",
  yourInviteQrCode: "Din QR-kod för inbjudan",
  inviteLink: "Inbjudningslänk",
  scanQrOrUseLink: "Skanna denna QR-kod eller använd denna länk för att skicka en vänförfrågan",
  copyInviteLink: "Kopiera inbjudningslänk",
  goToItem: "Gå till objekt",
  verificationEmailSent: "Verifieringsmejl skickat! Kontrollera din inkorg.",
  verificationEmailFailed: "Det gick inte att skicka verifieringsmejlet. Försök igen.",
  verifyYourEmail: "Verifiera din e-postadress",
  verifyEmailInstructions: "Verifiera din e-postadress för att få tillgång till ditt konto. Kontrollera din inkorg efter verifieringslänken.",
  sending: "Skickar...",
  resendVerificationEmail: "Skicka verifieringsmejl igen",
  login: "Logga in",
  register: "Registrera dig",
  home: "Hem",
  calendar: "Kalender",
  friends: "Vänner",
  profile: "Profil",
  logout: "Logga ut",
  loading: "Laddar...",
  language: "Språk",
  calendarSelectPlaceSuggestion: "Välj en plats från förslagen så att koordinater bifogas.",
  calendarSelectDateAndTime: "Välj datum och tid.",
  calendarPositiveDuration: "Ange en positiv varaktighet.",
  calendarFutureDateRequired: "Datum och tid för evenemanget måste vara i framtiden.",
  calendarCreateEventFailed: "Det gick inte att skapa evenemanget. Försök igen.",
  cancel: "Avbryt",
  createNewEvent: "Skapa nytt evenemang",
  week: "Vecka",
  month: "Månad",
  eventTitle: "Titel",
  date: "Datum",
  time: "Tid",
  duration: "Varaktighet",
  endsAt: "Slutar",
  place: "Plats",
  searchForPlace: "Sök efter en plats",
  placeSearchTip: "Tips: börja skriva och välj ett resultat för att bifoga koordinater.",
  description: "Beskrivning",
  createEvent: "Skapa evenemang",
  today: "Idag",
  previousMonth: "Föregående månad",
  nextMonth: "Nästa månad",
  previous: "Föregående",
  next: "Nästa",
  mondayShort: "Mån",
  tuesdayShort: "Tis",
  wednesdayShort: "Ons",
  thursdayShort: "Tor",
  fridayShort: "Fre",
  saturdayShort: "Lör",
  sundayShort: "Sön",
  more: "mer",
  mustRespondWillBeforeReposting: "Du måste svara \"Kommer\" innan du delar vidare",
  event: "Evenemang",
  backToCalendar: "Tillbaka till kalendern",
  addToGoogleCalendar: "Lägg till i Google Kalender",
  when: "När",
  where: "Var",
  openLocationInGoogleMaps: "Öppna plats i Google Maps",
  hosts: "Värdar",
  yourResponse: "Ditt svar",
  currentResponse: "Nuvarande svar",
  response_will: "Kommer",
  response_might: "Kanske kommer",
  response_wont: "Kommer inte",
  willRunIntoYou: "Jag tittar förbi",
  mightDropBy: "Jag kanske tittar förbi",
  wontCome: "Jag kommer inte",
  repostToMyFriends: "Dela vidare till mina vänner",
  responses: "Svar",
  willAttend: "Kommer att delta",
  reposted: "Delat vidare",
  mightAttend: "Kanske deltar",
  cancelEvent: "Avbryt evenemang",
  cancellationEmailNoticeBefore: "Personer som har svarat att de kommer",
  cancellationEmailNoticeAfter: "kommer att få ett e-postmeddelande om att evenemanget har ställts in.",
  optionalCancellationMessage: "Valfritt meddelande till deltagare (max 1000 tecken)",
  confirmCancelEvent: "Bekräfta avbokning av evenemang",
  clear: "Rensa",
  confirmCancellation: "Bekräfta avbokning",
  confirmCancellationMessage: "Är du säker på att du vill avbryta detta evenemang? Bekräftade deltagare kommer att meddelas och evenemanget tas bort.",
  eventCancelledNotified: "Evenemanget har avbrutits. Meddelade:",
  attendees: "deltagare",
  failedToCancelEvent: "Det gick inte att avbryta evenemanget",
  back: "Tillbaka",
  cancelled: "Avbrutet",
  ok: "OK",
  forgotPassword: "Glömt lösenord",
  email: "E-post",
  passwordResetLinkSent: "Om kontot finns har en återställningslänk skickats.",
  passwordResetRequestFailed: "Det gick inte att begära återställning av lösenord.",
  sendResetLink: "Skicka återställningslänk",
  addFriend: "Lägg till vän",
  incomingRequests: "Inkommande förfrågningar",
  accept: "Acceptera",
  deny: "Neka",
  myFriends: "Mina vänner",
  noFriendsYet: "Du har inga vänner ännu. Börja lägga till några!",
  seeProfile: "Se profil",
  noEventsToRespondTo: "Inga evenemang att svara på",
  allCaughtUp: "Du är uppdaterad. Kom tillbaka senare för nya evenemang från dina vänner.",
  events: "Evenemang",
  unknown: "Okänd",
  noDescriptionProvided: "Ingen beskrivning angiven.",
  will: "Ja",
  maybe: "Kanske",
  wont: "Nej",
  userNotFound: "Användaren hittades inte",
  friendRequestSentSuccessfully: "Vänförfrågan skickades!",
  friendInvitation: "Väninbjudan",
  sendFriendRequest: "Skicka vänförfrågan",
  loginToSendFriendRequest: "Logga in för att skicka en vänförfrågan",
  chooseLanguage: "Välj språk",
  invalidCredentials: "Ogiltiga inloggningsuppgifter. Försök igen.",
  username: "Användarnamn",
  password: "Lösenord",
  forgotPasswordQuestion: "Glömt lösenordet?",
  dontHaveAccount: "Har du inget konto?",
  registerHere: "Registrera dig här",
  invalidProfilePhotoType: "Ogiltig filtyp. Ladda upp en JPEG-, PNG-, GIF- eller WebP-bild.",
  invalidFileExtension: "Ogiltig filändelse",
  allowedExtensions: "Tillåtna",
  fileTooLarge: "Filen är för stor",
  maximumFileSize: "Maximalt",
  profilePhotoRemoved: "Profilbilden har tagits bort.",
  failedToRemoveProfilePhoto: "Det gick inte att ta bort profilbilden",
  profileUpdatedSuccessfully: "Profilen har uppdaterats!",
  failedToUpdateProfile: "Det gick inte att uppdatera profilen",
  privateEmailExplanation: "Endast du kan se din e-postadress för att undvika oönskade meddelanden utanför plattformen",
  yourEmailIsPrivate: "Din e-postadress är privat.",
  profilePhoto: "Profilbild",
  removePhoto: "Ta bort foto",
  firstName: "Förnamn",
  lastName: "Efternamn",
  tellPeopleAboutYourself: "Berätta om dig själv",
  whereToContactMe: "Hur man kontaktar mig",
  contactInfoPlaceholder: "Instagram: myUsername\nDiscord: myDiscord",
  save: "Spara",
  notSet: "Inte angivet",
  editProfile: "Redigera profil",
  imageToCrop: "Bild att beskära",
  zoom: "Zoom",
  usePhoto: "Använd foto",
  name: "Namn",
  whereToContact: "Kontaktuppgifter",
  removeFriendship: "Ta bort vänskap",
  confirmRemoveFriend: "Bekräfta borttagning av vän",
  confirmRemoveFriendBefore: "Är du säker på att du vill ta bort",
  confirmRemoveFriendAfter: "från din vänlista?",
  friendRemoved: "Vän borttagen.",
  failedToRemoveFriend: "Det gick inte att ta bort vännen.",
  confirmRemove: "Bekräfta borttagning",
  error: "Fel",
  removed: "Borttagen",
  passwordsDoNotMatch: "Lösenorden matchar inte",
  registrationFailed: "Registreringen misslyckades. Försök igen.",
  confirmPassword: "Bekräfta lösenord",
  alreadyHaveAccount: "Har du redan ett konto?",
  loginHere: "Logga in här",
  passwordResetSuccessfully: "Lösenordet har återställts.",
  failedToResetPassword: "Det gick inte att återställa lösenordet.",
  resetPassword: "Återställ lösenord",
  newPassword: "Nytt lösenord",
  confirmNewPassword: "Bekräfta nytt lösenord",
  setNewPassword: "Ange nytt lösenord",
  emailVerifiedSuccessfully: "E-postadressen har verifierats!",
  emailVerificationFailed: "Verifieringen misslyckades. Länken kan vara ogiltig eller ha gått ut.",
  verifying: "Verifierar...",
  verified: "Verifierad!",
  redirectingToHome: "Omdirigerar till startsidan...",
  verificationFailed: "Verifieringen misslyckades",
  goToHome: "Gå till startsidan",
  about: "Om",
  aboutConceptTitle: "Koncept",
  aboutCreatorIntroduction: "Hej, jag är Crypt0, klättrare och skapare av Run Into Me.",
  aboutCreatorStory: "Jag skapade webbplatsen eftersom jag är social och lade för mycket tid på att ordna klättring med andra.",
  aboutPlanningProblem: "Jag ville kunna meddela alla samtidigt när och var jag skulle klättra, utan en formell inbjudan.",
  aboutDeveloperSolution: "Då kom jag ihåg att jag är utvecklare och kunde bygga lösningen själv.",
  aboutWelcome: "Välkommen till Run Into Me, där du berättar för vänner om aktiviteter som de kan delta i utan press.",
  aboutCallToAction: "Publicera nästa aktivitet som är roligare tillsammans här!",
  aboutTutorialTitle: "Guide",
  aboutCalendarCreateEvent: "I kalendervyn kan du även skapa en ny händelse.",
  aboutEventColorsIntroduction: "Färgerna visar deltagandestatus:",
  aboutColorGold: "Guld",
  aboutColorGoldDescription: "Du är värd för händelsen.",
  aboutColorGreen: "Grön",
  aboutColorGreenDescription: "Du deltar i händelsen.",
  aboutColorOrange: "Orange",
  aboutColorOrangeDescription: "Du svarade ”kanske”.",
  aboutColorBlue: "Blå",
  aboutColorBlueDescription: "Du har inte svarat än.",
  aboutColorGray: "Grå",
  aboutColorGrayDescription: "Du avböjde inbjudan.",
  aboutCalendarEventDetails: "Klicka på en händelse för information och svar.",
  aboutFriendPageTitle: "Vänsida",
  aboutFriendPageDescription: "Ange användarnamn eller skicka inbjudningslänk / QR-kod.",
  aboutHomePageTitle: "Startsida",
  aboutHomePageDescription: "Se kommande händelser och ange om du kommer.",
  aboutRepostScreenTitle: "Skärm för återpublicering",
  aboutGoogleCalendarDescription: "Lägg till händelsen i Google Kalender med knappen.",
  aboutRepostDescription: "Efter bekräftelse kan du återpublicera händelsen för vänner.",
};

export default sv;